import React from 'react';
import {hasRole} from '../../../../utils/hasRole';

export default function ReceiptWriteAccess({children}) {
  return hasRole('ROLE_RECEIPT_WRITE') ? children : null;
}
